import { Component, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { EmailService } from 'src/app/core/services/email/email.service';
import { FormService } from 'src/app/core/services/form/form.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';


@Component({
  selector: 'visitor-desktop-contact',
  templateUrl: './desktop-contact.component.html',
  styleUrls: ['./desktop-contact.component.css']
})
export class DesktopContactComponent implements OnInit {

  public form: FormGroup;

  constructor(
    private formService: FormService,
    private emailService: EmailService,
    private notificationService: NotificationService,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
  }

  public buildForm(): void {
    this.form = this.formService.buildFormGroup({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required]]
    });
  }

  public controlIsRequired(formControlName: string): boolean {
    return this.formService.controlIsRequired(this.form, formControlName);
  }

  public controlIsInvalid(formControlName: string): boolean {
    return this.formService.controlIsInvalid(this.form, formControlName);
  }

  public controlIsInvalidEmail(formControlName: string): boolean {
    return this.formService.controlIsInvalidEmail(this.form, formControlName);
  }

  public controlIsInvalidPattern(formControlName: string): boolean {
    return this.formService.controlIsInvalidPattern(this.form, formControlName);
  }

  public controlIsInvalidLength(formControlName: string): boolean {
    return this.formService.controlIsInvalidLength(this.form, formControlName);
  }

  onSubmit(form: FormGroupDirective): void {

    if (this.form.valid) {
      const toEmail = form.value.email
      const name = form.value.name
      const message =`Nombre : ${name}
      Email : ${form.value.email}
      Message: ${form.value.message}
      `

      this.emailService.sendEmail(toEmail, message)
        .then((response) => {
          this.notificationService.success('Mensaje enviado')
          this.form.reset();
          form.resetForm();
          console.log('Correo electrónico enviado:', response);
        }, (error) => {
          console.log('Error al enviar correo electrónico:', error);
        });

    }
  }

}
